export default "__VITE_ASSET__e1b658a1__"